import { render, staticRenderFns } from "./GCoinsDeposit.vue?vue&type=template&id=3ec8d9fc&scoped=true"
import script from "./GCoinsDeposit.vue?vue&type=script&lang=js"
export * from "./GCoinsDeposit.vue?vue&type=script&lang=js"
import style0 from "./GCoinsDeposit.vue?vue&type=style&index=0&id=3ec8d9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8d9fc",
  null
  
)

export default component.exports